export const environment = {
  name: 'qa',
  production: false,
  maintenanceMode: false,
  showAccessBanner: false,
  useEntraId: true,
  openidUrl: 'https://corpqa.sts.ford.com/adfs/oauth2',
  openidClientId: 'urn:agenda:clientid:web_agendadealer:qa',
  openidResource: 'urn:agenda:resource:web_agendadealer:qa',
  openidRedirectUrl: '',
  bffUrl: 'https://api-qat.service.ford.com/agenda/manage-reservation-bff',
  dealerTransformationUrl: 'https://qa.mfe.agenda.ford.com/home',
  workshopOldUrl: 'https://qa.mfe.agenda.ford.com/workshop-old',
  workshopUrl: 'https://qa.mfe.agenda.ford.com/workshop',
  backofficeUrl: 'https://qa.backoffice.agenda.ford.com',
  msalConfig: {
    clientId: 'be140806-ab40-4023-9dd4-c39e3451a812',
    authority: 'https://login.microsoftonline.com/2c6104e8-71bb-4ad5-9be2-4d6321af2f5a',
    redirectUri: 'https://qa.dealer.agenda.ford.com',
  },
  apiConfig: {
    manageReservationBff: {
      uri: 'https://api-qat.service.ford.com/agenda/manage-reservation-bff',
      scopes: ['api://3a83058f-ee59-40c7-b98a-7fb55ded3803/webapp'],
    },
  },
};
